export default __webpack_public_path__ + "assets/futureOfTransport.e7e77cb3.png";